import { Alert, AlertIcon, Text } from 'components/v4';
import InstructionMessages from './InstructionMessages';

import { operatorInstruction } from './constants';

/**
 * Queue status message component
 * @param {Object} props
 * @param {string|null} props.error - Error message to display
 * @param {boolean} props.darkMode - Dark mode flag
 */
function QueueStatusMessage({ error, darkMode }) {
    if (error) {
        return (
            <Alert status="error">
                <AlertIcon />
                <Text>{error}</Text>
            </Alert>
        );
    }

    return (
        <InstructionMessages
            instructionBody={operatorInstruction}
            darkMode={darkMode}
            keywords={['15 minutes', 'auto refresh']}
        />
    );
}

export default QueueStatusMessage;
